import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, Flag, Wrench } from 'lucide-react';
import { Reveal } from '../Reveal';

export const ServiceCaseStudy = ({ data, accent, accentDark, index, testidPrefix }) => (
  <section aria-labelledby={`${testidPrefix}-case-study-heading`} data-testid={`${testidPrefix}-case-study-section`} className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="rounded-2xl border border-slate-200 bg-mist p-8 sm:p-12">
          <div className="max-w-2xl">
            <p className="flex items-center gap-3">
              <span className="font-mono text-xs font-medium tracking-widest" style={{ color: accent }}>{index}</span>
              <span className="text-xs font-bold uppercase tracking-[0.2em]" style={{ color: accent }}>{data.eyebrow}</span>
            </p>
            <h2 id={`${testidPrefix}-case-study-heading`} data-testid={`${testidPrefix}-case-study-heading`} className="mt-4 text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
              {data.heading}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">{data.intro}</p>
          </div>

          <div className="mt-10 grid gap-8 md:grid-cols-3 md:gap-6 lg:gap-10">
            <div data-testid={`${testidPrefix}-case-study-challenge`}>
              <p className="flex items-center gap-2.5 text-xs font-bold uppercase tracking-[0.18em] text-navy-900">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-navy-900 text-white">
                  <Flag className="h-4 w-4" aria-hidden="true" />
                </span>
                {data.challenge.title}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base">{data.challenge.text}</p>
            </div>
            <div data-testid={`${testidPrefix}-case-study-solution`} className="md:border-l md:border-slate-200 md:pl-6 lg:pl-10">
              <p className="flex items-center gap-2.5 text-xs font-bold uppercase tracking-[0.18em] text-navy-900">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-navy-900 text-white">
                  <Wrench className="h-4 w-4" aria-hidden="true" />
                </span>
                {data.solution.title}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base">{data.solution.text}</p>
            </div>
            <div data-testid={`${testidPrefix}-case-study-results`} className="md:border-l md:border-slate-200 md:pl-6 lg:pl-10">
              <p className="flex items-center gap-2.5 text-xs font-bold uppercase tracking-[0.18em]" style={{ color: accentDark }}>
                <span className="flex h-8 w-8 items-center justify-center rounded-lg text-white" style={{ backgroundColor: accent }}>
                  <CheckCircle2 className="h-4 w-4" aria-hidden="true" />
                </span>
                {data.results.title}
              </p>
              <ul className="mt-4 space-y-3">
                {data.results.points.map((point) => (
                  <li key={point} className="flex items-start gap-2.5 text-sm font-semibold text-navy-800 sm:text-base">
                    <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" style={{ color: accent }} aria-hidden="true" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <Link
            to={data.cta.href}
            data-testid={`${testidPrefix}-case-study-read-more`}
            className="group mt-10 inline-flex items-center gap-2 rounded-md bg-navy-900 px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-navy-700"
          >
            {data.cta.label}
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
